<template>
	<div>
		<modal :show.sync=show :hide-footer="true">
			<h3 slot="header" class="mb-0 font-weight-500">Create New Customer</h3>

			<ValidationObserver v-slot="{ invalid }" ref="observer">
				<b-form  ref="customerForm">
					<b-row>
						<b-col cols="12">
							<div class="d-flex align-items-center my-2">
								<div>
									<el-switch style="display: block" v-model="is_existing_customer"
										active-color="#099A78" :active-value="1" :inactive-value="0">
									</el-switch>
								</div>
								<div class="ml-2">
									<strong>Use Existing Customer</strong>
								</div>
							</div>
						</b-col>
						<template v-if="is_existing_customer == 1">
							<b-col cols="12">
								<b-form-group label="Find Customer Name Or IC:">
									<ValidationProvider v-slot="{ errors }" :rules="{ required: true }" :vid="'customerId'">
										<el-select
											v-model="existing_customer.id"
											filterable
											remote
											reserve-keyword
											placeholder="Find Customer Name Or IC"
											:remote-method="findCustomer"
											:loading="is_loading_find_customer">
											<el-option
												v-for="(item,index) in existingCustomerList"
												:key="index"
												:label="item.name + ' ( IC: '+item.nric+' )'"
												:value="item.id">
											</el-option>
										</el-select>
										<small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
									</ValidationProvider>
								</b-form-group>
							</b-col>
						</template>
						<template v-else>
							<b-col cols="12">
								<b-form-group label="Customer Name:">
									<ValidationProvider v-slot="{ errors }" :rules="{ required: true }" :vid="'customerName'">
										<b-form-input v-model="new_customer.name" type="text" required></b-form-input>
										<small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
									</ValidationProvider>
								</b-form-group>
							</b-col>

							<b-col cols="12">
								<b-form-group label="Customer NRIC:">
									<ValidationProvider v-slot="{ errors }" :rules="{ required: true }" :vid="'customerNric'">
										<b-form-input v-model="new_customer.nric" type="text" required
										@keydown="preventNonNumericInput"></b-form-input>
										<small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
									</ValidationProvider>
								</b-form-group>
							</b-col>

							<b-col cols="12">
								<b-form-group label="Contact No.:">
									<div class="d-flex justify-content-end">
										<!-- <div class="col-md-3 p-0 m-0 mr-1">
											<b-form-input v-model="new_customer.country_code" maxlength="3"></b-form-input>
										</div> -->
										<div class="col-md-12 p-0 m-0">
											<ValidationProvider v-slot="{ errors }" :rules="{ required: true, phone_prefix: true }"
												:vid="'customerContact'">
												<b-form-input v-model="new_customer.phone_no" type="text" required
													@keydown="preventNonNumericInput"></b-form-input>
												<small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
											</ValidationProvider>
										</div>
									</div>
								</b-form-group>
							</b-col>
						</template>
						<b-col md="6" sm="12" class="mx-auto text-center mt-4 pt-2">
							<el-button type="primary" @click.prevent="submit" class="w-100" :disabled="invalid" :loading="is_loading">Create</el-button>
						</b-col>
					</b-row>
				</b-form>
			</ValidationObserver>
		</modal>
	</div>
</template>
<script>
import Modal from "@/components/Modal"
import { Select, Option, Button, Switch } from 'element-ui'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import '@/assets/js/formValidations.js'
import { preventNonNumericInput } from '@/assets/js/formValidations.js'
import { useCustomerStore } from '@/stores/customerStore';
import { mapActions } from 'pinia';
import { apiDomain, services } from '@/assets/js/config.js';

export default {
	props: {
		create_new: Boolean
	},
	components: {
		Modal,
		ValidationObserver,
		ValidationProvider,
		[Button.name]: Button,
		[Select.name]: Select,
		[Option.name]: Option,
		[Switch.name]: Switch,
	},
	data() {
		return {
			is_loading: false,
			is_existing_customer: 0,
			is_loading_find_customer: false,
			existingCustomerList: [],
			new_customer: {
				name: '',
				nric: '',
				phone_no: '',
				country_code: '',
			},
			existing_customer: {
				id: ''
			},
			show: false,
		}
	},
	methods: {
		preventNonNumericInput,
		...mapActions(useCustomerStore, ['createCustomer', 'createLoanEcByExisCust','getLoanEcList','getCustomer','getLoanEC','getCustomerInvList']),
		viewCreateCustomer() {
			this.show = !this.show
		},
		getMainStatus() {
			axios.get(services.customer + 'customer/statuses?status_type=main', { headers: getHeader() })
				.then(res => {
				this.main_status = res.data.data
				})
				.catch(e => {
				_gNotif.errorFunction(e)
				})
		},
		async findCustomer(query){
			if (query !== '' && query.length > 2) {
				this.is_loading_find_customer = true;
				const params = {
					search: {
						search_txt:query
					},
					paginate: 10
				};
				const dataList = await this.getCustomerInvList(params, true);

				this.existingCustomerList = [];
				for (let i = 0; i < dataList.data.length; i++) {
					const el = dataList.data[i];
					this.existingCustomerList.push({
						id: el.id,
						im2u_id: el.im2u_id,
						name: el.name,
						nric: el.nric,
						phone_no: el.phone_no
					})
				}
				this.is_loading_find_customer = false;
			} else {
				this.existingCustomerList = [];
				this.is_loading_find_customer = false;
			} 
		},
		submit() {
			this.is_loading = true;
			if(this.is_existing_customer){
				const exCust = this.existingCustomerList.find(item => item.id == this.existing_customer.id);	
				this.createLoanEcByExisCust(exCust.id, exCust.im2u_id).then((item) => {
					this.getCustomer(item.customer_id).then(resp => {
						this.getLoanEC(item.id, item.customer_id).then(resp => {
							this.$router.push('/customer/pending-customer-detail/'+resp.customer_id+'?lec_id='+resp.id);
							this.is_loading = false;
						}).catch(err=>{
							this.is_loading = false;
						});
					})
				}).catch((error) => {
					this.is_loading = false;
				});
			}else{
				this.createCustomer(this.new_customer).then((item) => {
					this.getCustomer(item.customer_id).then(resp => {
						this.getLoanEC(item.id, item.customer_id).then(resp => {
							this.$router.push('/customer/pending-customer-detail/'+resp.customer_id+'?lec_id='+resp.id);
							this.is_loading = false;
						}).catch(err=>{
							this.is_loading = false;
						});
					})
				}).catch((error) => {
					this.is_loading = false;
				});
			}
		},
	}
}
</script>